import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import UserService from '../../services/UserService';
import useDocumentTitle from '../../hooks/useDocumentTitle';

export default function LogoutPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('navigation.logout'));

  useEffect(() => {
    // Clear session token and guest token
    localStorage.removeItem('session_token');
    localStorage.removeItem('guest_token');
    localStorage.removeItem('has_hardcore_access');

    // Clear settings
    localStorage.removeItem('show_help_bubble');
    localStorage.removeItem('show_mule_bubble');
    localStorage.removeItem('show_tracker_bubble');
    localStorage.removeItem('show_scrollable_icon_left');
    localStorage.removeItem('show_scrollable_icon_right');
    localStorage.removeItem('show_filter_bubble');

    // Reset UserService state
    const userService = UserService.getInstance();
    userService.clearCache();

    // Refresh the page
    window.location.href = '/';
  }, []);

  return null;
}
